import React, { useState } from 'react';
import { observer } from 'mobx-react';
import clsx from 'clsx';
import BaseballMatchGameBoxScore from './boxScore';
import BaseballMatchGameSpecial from './special';
import SportsTeamLogo from '../../../../../components/teamLogo';
import MatchTracker from '../../../shared/matchTracker';
import BaseBallMatchTracker from './MatchTracker';
import {getStreamBrowser} from "../../../liveStream/util";

const BaseballMatchGame = observer(({ item }) => {
  const {
    getTeamData,
    getMatchGameTime,
    venueName,
    winnerTeam,
    statusText,
    getBaseballPlayer,
    getTypeData
  } = item;
  const [selectedTab, setSelectedTab] = useState('score');

  const onClickDetailTab = (type) => {
    setSelectedTab(type);
  };
  const onClickVideo = () => {
    getStreamBrowser(item.videoLink);
  };

  return (
    <div className="score_detail_board baseball">
      {/* summary_score */}
      <div className="summary_score">
        <div className="team left">
          <SportsTeamLogo
            className="logo"
            imgSize={33}
            imgUrl={getTeamData.home.imgPath}
            isLazy={false}
            location="home"
          />
          <span className="name">{getTeamData.home.name}</span>
          <span className="player">{getBaseballPlayer.home.player}</span>
        </div>
        <div className="info">
          <div className="score">
            <strong
              className={clsx(
                'left',
                winnerTeam.activeScore === 'home' && 'on'
              )}
            >
              <em className="num">{getTeamData.home.score}</em>
            </strong>
            <div className="state">
              <span>{statusText}</span>
            </div>
            <strong
              className={clsx(
                'right',
                winnerTeam.activeScore === 'away' && 'on'
              )}
            >
              <em className="num">{getTeamData.away.score}</em>
            </strong>
          </div>
          <div className="time">{getMatchGameTime}</div>
          {!!item.videoLink &&
              ( item.gameStatus === "IN_PROGRESS" || item.gameStatus === "BREAK_TIME" || item.gameStatus === "PAUSE" )
              && (
              <div className="video">
                <a target="_blank" onClick={onClickVideo} className="tag">생중계</a>
              </div>
          )}
          <div className="stadium">{!!venueName && venueName}</div>
        </div>
        <div className="team right">
          <SportsTeamLogo
            className="logo"
            imgSize={33}
            imgUrl={getTeamData.away.imgPath}
            isLazy={false}
            location="away"
          />
          <div className="name">{getTeamData.away.name}</div>
          <span className="player">{getBaseballPlayer.away.player}</span>
        </div>
      </div>
      {/* // summary_score */}
      {/* detail_score */}
      <div className="detail_score">
        <ul className="tab">
          <li>
            <button
              className={clsx(selectedTab === 'score' && 'selected')}
              onClick={() => onClickDetailTab('score')}
            >
              스코어
            </button>
          </li>
          <li>
            <button
              className={clsx(selectedTab === 'special' && 'selected')}
              onClick={() => onClickDetailTab('special')}
            >
              스페셜
            </button>
          </li>
          {getTypeData.currentBatter !== null &&
            getTypeData.currentPitcher !== null && (
              <li>
                <button
                  className={clsx(selectedTab === 'matchTracker' && 'selected')}
                  onClick={() => onClickDetailTab('matchTracker')}
                >
                  상황중계
                </button>
              </li>
            )}
        </ul>

        {selectedTab === 'matchTracker' && <BaseBallMatchTracker item={item} />}

        {selectedTab !== 'matchTracker' && (
          <div className="detail_board">
            <div className="team">
              <span>{getTeamData.away.name}</span>
              <span>{getTeamData.home.name}</span>
            </div>

            {selectedTab === 'score' ? (
              <BaseballMatchGameBoxScore item={item} />
            ) : (
              <BaseballMatchGameSpecial item={item} />
            )}
          </div>
        )}
      </div>
      {/* // detail_score */}
    </div>
  );
});

export default BaseballMatchGame;
